import { FC, useState } from 'react';
import { Box } from '@hopskipdrive/react-components';

import { Pagination } from '../../../../../shared/components/Pagination';
import { useRiderContactsQuery } from '../../../../hooks/useRiderContactsQuery';
import { replaceUnderscoreWithSpacePascalCase } from '../../../PageHeading/utils';

import { CONTACT_QUERY_PARAMS } from './constants';
import { RiderContact, SkeletonContact } from './RiderContact';

interface RiderContactsProps {
  riderSlug: string;
}

export const RiderContacts: FC<RiderContactsProps> = ({ riderSlug }) => {
  const [pageNumber, setPageNumber] = useState<number>(CONTACT_QUERY_PARAMS.page);
  const { data: riderContactsData, isFetching } = useRiderContactsQuery({
    riderSlug: riderSlug,
    page: pageNumber,
    perPage: CONTACT_QUERY_PARAMS.perPage,
  });

  return (
    <Box display="flex" flexDirection="column" gap="12px">
      <ListOfRiderContacts
        isFetching={isFetching}
        showPagination={riderContactsData?.data.length === CONTACT_QUERY_PARAMS.perPage || pageNumber > 1}
        riderContacts={riderContactsData?.data}
        onPageChange={(_, page) => setPageNumber(page)}
      />
    </Box>
  );
};

// To facilitate testing, we can export the unconnected component as well
export const ListOfRiderContacts = ({ isFetching, riderContacts, showPagination, onPageChange }) => {
  return (
    <Box display="flex" flexDirection="column" gap="4px">
      {isFetching ? (
        <SkeletonContact />
      ) : (
        <>
          {riderContacts?.map((riderContact, index) => (
            <RiderContact
              key={`${riderContact.organizerSlug}-${index}`}
              slug={riderContact.organizerSlug}
              name={`${riderContact.firstName} ${riderContact.lastName}`}
              permissions={riderContact.permissions}
              phone={riderContact.mobilePhoneNumber}
              email={riderContact.email}
              contactRole={replaceUnderscoreWithSpacePascalCase(riderContact.role)}
            />
          ))}
        </>
      )}
      {showPagination && <Pagination count={2} siblingCount={0} onChange={onPageChange} />}
    </Box>
  );
};
